import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function RouteTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (localStorage.getItem("mediolanum_cookie_consent") !== "all") return;
    api.post("/track", { path: pathname }).catch(() => {});
  }, [pathname]);

  return null;
}
